var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showUserDataError)?_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.showUserDataError))])]):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }